function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, Array, String, toasts) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'mp-toast-area': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = (toasts);
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, toast, $index) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-toast", {
                  "on": {
                    action: () => $helpers.toastAction(toast),
                    close: () => $helpers.toastClose(toast),
                    undo: () => $helpers.toastUndo(toast),
                  },
                  "attrs": {
                    cta: toast.cta || '',
                    hide: toast.hide,
                    'is-error': toast[`is-error`],
                    undoable: toast.undoable,
                    type: toast.type,
                  },
                }, [__vjadeSafeCode(toast.message)]));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var $index = $$objKey;
                if ($$obj.hasOwnProperty($index)) {
                  $$iterated = true;
                  var toast = $$obj[$index];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-toast", {
                      "on": {
                        action: () => $helpers.toastAction(toast),
                        close: () => $helpers.toastClose(toast),
                        undo: () => $helpers.toastUndo(toast),
                      },
                      "attrs": {
                        cta: toast.cta || '',
                        hide: toast.hide,
                        'is-error': toast[`is-error`],
                        undoable: toast.undoable,
                        type: toast.type,
                      },
                    }, [__vjadeSafeCode(toast.message)]));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "toasts" in locals ? locals.toasts : typeof toasts !== "undefined" ? toasts : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;